import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07176a32"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 持有 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 详情 ")
const _hoisted_3 = {
  key: 0,
  class: "light"
}
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Charts = _resolveComponent("Charts")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    width: _ctx.width,
    visible: _ctx.visible,
    height: 'calc(100% - 212px)',
    "body-style": _ctx.bodyStyle,
    drawerStyle: _ctx.drawerStyle,
    wrapClassName: _ctx.wrapClassName,
    mask: false,
    getContainer: _ctx.getContainer
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("strong", null, _toDisplayString((_ctx.currentshareholder || {}).SHName || ''), 1),
        _hoisted_1,
        _createElementVNode("strong", null, _toDisplayString(_ctx.currentshareholder.name), 1),
        _hoisted_2
      ]),
      ((_ctx.tableData || []).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_Charts, {
              id: _ctx.title,
              theme: 'light',
              option: _ctx.option,
              style: {height: '240px'}
            }, null, 8, ["id", "option"]),
            _createVNode(_component_Table, {
              data: _ctx.tableData,
              columns: _ctx.columns,
              theme: 'light',
              bordered: true,
              pagination: _ctx.total2 > 10 ? _ctx.pagination2 : false
            }, null, 8, ["data", "columns", "pagination"])
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_4, [
            _createVNode(_component_Nodata, { nodatadesc: '股东持股详情' })
          ]))
    ]),
    _: 1
  }, 8, ["width", "visible", "height", "body-style", "drawerStyle", "wrapClassName", "getContainer"]))
}